import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from 'src/styles/utils';
import { Box } from '../Box';
import GlImage from '../Image';
import { Text } from '../Text';

export const PressBarContainer = styled('div')`
  display: flex;
  flex-direction: column;
  ${mediaQueries.tablet} {
    flex-direction: column-reverse;
  }
`;

export const PressItem = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
}
`;

export const StyledImage = styled(GlImage)`
  max-width: ${pxToRem(155)};
  max-height: ${pxToRem(72)};
  width: 100%;
  height: auto;
  margin-left: 0.5rem;
  margin-right: 0.5rem;

  ${mediaQueries.tablet} {
    max-width: ${pxToRem(155)};
    max-height: ${pxToRem(50)};
  }
`;

export const PressText = styled(Text)`
  letter-spacing: 0.0625rem;
`;
